import Button from 'components/buttons/Button';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OutlinedButton: FunctionComponent<Props> = ({
    children,
    className = '',
    disabled,
    onClick,
    testId = TEST_ID
}) => (
    <Button
        className={`${styles.outlinedButton} ${className}`}
        disabled={disabled}
        onClick={onClick}
        testId={testId}
        variant="outlined"
    >
        {children}
    </Button>
);

export default OutlinedButton;
